

const style: any = (): any => ({
	switchContainer:{
		height: 38,
		display: "flex",
		alignItems: "center",
	}
});

export default style;